import Model from "../common/model";

/**
 * Represents a Credits Policy with applied credits, features, devices, and validity details.
 */
export default class CreditsPolicyModel implements Model {
  id!: string;
  createdAt!: Date;
  updatedAt!: Date;
  policyName!: string;
  creditType!: string;
  appliedCredits!: string;
  appliedPriorityPostings!: string;
  appliedLevel!: string;
  description!: string;
  policyCost!: string;
  policyValidity!: { startDate: string; endDate: string };
  validityPeriod!: { duration: string; unit: string };
  appliedFeatures!: string[];
  devices!: DevicePolicy[];

  constructor(init?: Partial<CreditsPolicyModel>) {
    if (init) Object.assign(this, init);
  }
}

/**
 * Represents a device configuration under a credits policy.
 */
export interface DevicePolicy {
  _id: string;
  bluPodCost: number;
  bluEyeCost: number;
  gstPercentOnTotal: number;
  gstCostOnTotal: number;
  userLicenses: UserLicensesPolicy;
  renewals: RenewalPolicy[];
  additionalDevice: AdditionalDevicePolicy;
}

/**
 * Represents user licenses assigned to a device.
 */
export interface UserLicensesPolicy {
  rolesAccepted: RolePolicy[];
  rolesAssigendByDefault: RoleDefaultPolicy[];
  cost: number;
}

export interface RolePolicy {
  _id: string;
  roleID: string;
  roleName: string;
}

export interface RoleDefaultPolicy {
  _id: string;
  roleID: string;
  roleName: string;
  noOfLicencesByDefault: number;
}

/**
 * Represents renewal cost policy for a device.
 */
export interface RenewalPolicy {
  companySize: string;
  _id: string;
  blueEyeCost: number;
}

/**
 * Represents additional device discount and cost details.
 */
export interface AdditionalDevicePolicy {
  discountPercent: number;
  discountCost: number;
  bluEyeCost: number;
  renewalBluEyeCost: number;
}